import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { containers } from 'style';
import { Person } from '..';
import { renderers } from 'react-markdown';

class ContactPersonComponent extends PureComponent {
  getAboutText(person) {
    const { body } = this.props;
    if (body === '') {
      return `Reach out to ${
        person.name.split(' ')[0]
        } to learn more about this project or how we can help you.`;
    }
    return body;
  }
  render() {
    const { person, title, body, textColor } = this.props;

    return (
      <div id="ContactPersonComponent">
        <PersonWrapper textColor={textColor && textColor.hex}>
          {person &&
            person.map(person => (
              <Person
                {...person}
                showMeet={true}
                about={this.getAboutText(person)}
                key={person.id}></Person>
            ))}
        </PersonWrapper>
      </div>
    );
  }
}
const PersonWrapper = styled.div`
    text-align: center;
    @media (min-width: ${containers.medium}px) {
        text-align: left;
    }

    color: ${props => props.textColor || 'inherit'};

    .image_wrapper {
        max-width: 170px;
        margin-left: auto;
        margin-right: auto;
        @media (min-width: ${containers.medium}px) {
            max-width: inherit;
            margin-left: inherit;
            margin-right: inherit;
        }
    }
    .markdown {
        max-width: 220px;
        margin-left: auto;
        margin-right: auto;
        @media (min-width: ${containers.medium}px) {
            max-width: 100%;
            max-width: auto;
            margin-left: inherit;
            margin-right: inherit;
        }
    }
`;

export default ContactPersonComponent;
